'use strict';

(function (angular, app) {
    StoreDetailController.$inject = ['$location', '$window', '$document', '$interval', '$q', '$http', 'BASE_URL', 'storeService', 'IS_GOOGLE_AVAILABLE'];
    angular
        .module('jwsdw.storeDetail')
        .config(['$locationProvider', function($locationProvider) {
            $locationProvider.html5Mode(true);
            // $locationProvider.hashPrefix('?');
        }])
        .controller('StoreDetailController', StoreDetailController);

    /**
     * @class jwsdwStoreDetail.StoreDetailController
     * @description Initializes the StoreDetailController
     * @param {Object} $location browser location object
     * @param {Object} $window browser window object
     * @param {Object} $document browser document object
     * @param {Object} $interval AngularJS's wrapper for window.setInterval
     * @param {Object} $q promise service that provides promise functionality
     * @param {Object} $http http service that provides an API for ajax calls
     * @param {String} BASE_URL base url for service requests
     * @param {Object} storeService service for stores
     * @param {Boolean} IS_GOOGLE_AVAILABLE true if google maps was loaded successfully (provided though jwsdwSettings)
     * @constructor
     */
    function StoreDetailController($location, $window, $document, $interval, $q, $http, BASE_URL, storeService, IS_GOOGLE_AVAILABLE) {
        var vm = this,
            lat = $window.jwsdwStoreSettings.lat,
            lng = $window.jwsdwStoreSettings.lng,
            zoom = 15,
            gmap,
            markerIconUrl = app.urls.images.markerIcon,
            location,
            marker;

        vm.storeOpeningHours = $window.jwsdwStoreSettings.storeHours;
        vm.openNow = false;
        vm.isMyStore = $window.jwsdwStoreSettings.isMyStore;
        vm.storePromotions = $window.jwsdwStoreSettings.storePromotions.filter(function(promotion) {
            return promotion.picture;
        });
        vm.stores = [];

        vm.jackWolfskinCard = $window.jwsdwStoreSettings.storeServices.find(function(service) {
            return service.id === 'jackWolfskinCard';
        });
        vm.storeServices = $window.jwsdwStoreSettings.storeServices.filter(function(service) {
            return service.id !== 'jackWolfskinCard';
        });
        vm.setMyStoreLoading = false;

        vm.openWhatIsMyStorePicker = openWhatIsMyStorePicker;
        vm.setMyStore = setMyStore;
        vm.openPromotionPicker = openPromotionPicker;
        vm.openServicePicker = openServicePicker;
        vm.redirectToServicePage = redirectToServicePage;

        window.jwsdwStoreDetail = {
            'setMyStore': setMyStore
        };

        /**
         * @description activate function
         * @returns {void}
         */
        this.$onInit = function () {
            // activate google maps functionalities
            if (!IS_GOOGLE_AVAILABLE) {
                $window.jwsdwMediator.subscribe('activateGoogleMaps', function() {
                    location = new $window.google.maps.LatLng(lat, lng);
                    initMap();
                });
            } else {
                location = new $window.google.maps.LatLng(lat, lng);
                initMap();
            }

            vm.openNow = storeService.isStoreOpen(vm.storeOpeningHours);

            $interval(function() {
                vm.openNow = storeService.isStoreOpen(vm.storeOpeningHours);
            }, 1000 * 60);

            if ($location.search().openPicker === 'personalShoppingPicker' &&
                _hasService('personalShopping')) {
                $window.jwsdwMediator.publish('openPicker', 'personalShoppingPicker');
                if (_browserSupportsHistoryAPI()) {
                    $location.search('openPicker', null);
                } else {
                    $window.location.href = $window.location.pathname;
                }
            }

            _searchNearbyStores();
        };

        /**
         * @description Method to initialize the map
         * @returns {Boolean} true
         */
        function initMap() {
            var mapOptions = {
                'center': location,
                'zoom': zoom,
                'mapTypeId': $window.google.maps.MapTypeId.ROADMAP,
                'mapTypeControl': false,
                'streetViewControl': false,
                'fullscreenControl': false,
                'draggable': true
            };

            gmap = new $window.google.maps.Map($document[0].getElementById('jwsdw-map'), mapOptions);

            renderGoogleMapMarker();

            $window.google.maps.event.addDomListener($window, 'resize', function() {
                var center;
                if (gmap) {
                    center = gmap.getCenter();
                    $window.google.maps.event.trigger(gmap, 'resize');
                    gmap.setCenter(center);
                }
            });
            return true;
        }

        /**
         * @returns {Boolean} true
         */
        function renderGoogleMapMarker() {
            var geoLocation = new $window.google.maps.LatLng(lat, lng);
            marker = new $window.google.maps.Marker({
                'position': geoLocation,
                'map': gmap,
                'url': decodeURIComponent('https://www.google.com/maps/search/?api=1&query=Jack Wolfskin ' + $window.jwsdwStoreSettings.storeAddress),
                'animation': $window.google.maps.Animation.DROP,
                'icon': {
                    'url': markerIconUrl,
                    'scaledSize': new $window.google.maps.Size(28, 35),
                    'origin': new $window.google.maps.Point(0, 0),
                    'anchor': new $window.google.maps.Point(28 / 2, 35)
                }
            });

            $window.google.maps.event.addListener(marker, 'click', function() {
                window.open(marker.url.replace(/[()]/g, ''), '_blank');
            });

            return marker;
        }

        /**
         * @param {Boolean} isWhatIsMyStorePicker if true request comes from picker
         * @returns {Boolean} true if open
         */
        function setMyStore(isWhatIsMyStorePicker) {
            var defer = $q.defer(),
                params = {
                    'storeId': $window.jwsdwStoreSettings.storeId
                };

            if (!$window.jwsdwSettings.customerAuthenticated) {
                $window.jwsdwMediator.publish('openPicker', 'loginPicker', {
                    'level': isWhatIsMyStorePicker ? 2 : 1,
                    'callback': setMyStore
                });
                return;
            }

            if (!vm.isMyStore) {
                vm.setMyStoreLoading = true;

                params[window.jwsdwSettings.csrfTokenName] = window.jwsdwSettings.csrfTokenValue;
                $http({
                    'method': 'POST',
                    'url': BASE_URL + '/Customer-updatePreferredStore',
                    'params': params
                }).then(success, error);
            } else {
                defer.resolve();
            }

            return defer.promise;

            /**
             * @description Function on success
             * @returns {void}
             */
            function success() {
                vm.isMyStore = true;
                vm.setMyStoreLoading = false;
                $window.jwsdwMediator.publish('closePicker', 'whatIsMyStorePicker', true);
                defer.resolve();
            }

            /**
             * @description Function on success
             * @returns {void}
             */
            function error() {
                vm.setMyStoreLoading = false;
                defer.reject();
            }
        }

        /**
         * @description Method to open what is mystore picker
         * @returns {void}
         * @memberOf jwsdwStoreDetail.StoreDetailController
         */
        function openWhatIsMyStorePicker() {
            $window.jwsdwMediator.publish('openPicker', 'whatIsMyStorePicker', {
                'isMyStore': vm.isMyStore
            });
        }

        /**
         * @description Method to open promotion picker
         * @param {Object} promotion store promotion
         * @param {String} promotion.description description
         * @param {String} promotion.headline headline
         * @param {String} promotion.url url
         * @returns {void}
         * @memberOf jwsdwStoreDetail.StoreDetailController
         */
        function openPromotionPicker(promotion) {
            $window.jwsdwMediator.publish('openPicker', 'infoPicker', {
                'content': promotion.description,
                'width': 1,
                'isVisible': true,
                'showHeadline': true,
                'headline': promotion.headline,
                'link': promotion.url
            });
        }

        /**
         * @description Method to open promotion picker
         * @param {String} service store service
         * @returns {void}
         * @memberOf jwsdwStoreDetail.StoreDetailController
         */
        function openServicePicker(service) {
            if (service.id === 'personalShopping') {
                $window.jwsdwMediator.publish('openPicker', 'personalShoppingPicker', {});
            } else {
                $window.jwsdwMediator.publish('openPicker', 'infoPicker', {
                    'content': service.description,
                    'width': 1,
                    'isVisible': true,
                    'showHeadline': true,
                    'headline': service.headline,
                    'link': service.url
                });
            }
        }

        /**
         * @description Method to search stores by coordinates
         * @returns {void}
         */
        function _searchNearbyStores() {
            if (!lat || !lng) {
                return;
            }

            vm.searchLoading = true;
            vm.stores = [];


            storeService
                .searchByLocation(lat, lng)
                .then(searchSuccess, searchError);

            /**
             * @description Method called on success
             * @param {Object} response response object
             * @param {Object} response.stores stores container
             * @param {Object[]} response.stores.stores array of stores
             * @param {Object} response.stores.myStore myStore object
             * @param {Object} response.position coordinates container
             * @param {Number} response.position.lat latitude
             * @param {Number} response.position.lng longitude
             * @returns {void}
             */
            function searchSuccess(response) {
                vm.searchLoading = false;
                vm.stores = response.stores.stores
                    .filter(function(store) {
                        return store.id !== $window.jwsdwStoreSettings.storeId &&
                            /store/i.test(store.storeType);
                    })
                    .sort(sortStores);
            }

            /**
             * @description Method called on error
             * @returns {void}
             */
            function searchError() {
                vm.searchLoading = false;
                vm.stores = [];
                vm.error = 'SEARCH_ERROR';
            }
        }

        /**
         * @description Method to sort stores by store type - JW Store first
         * @param {Object} a store A
         * @param {Object} b store B
         * @returns {Number} 1, 0, -1
         */
        function sortStores(a, b) {
            if (/OwnStore|Franchise|Outlet/i.test(a.storeType) && !/OwnStore|Franchise|Outlet/i.test(b.storeType)) {
                return -1;
            } else if (!/OwnStore|Franchise|Outlet/i.test(a.storeType) && /OwnStore|Franchise|Outlet/i.test(b.storeType)) {
                return 1;
            }
            if (a.distance === b.distance) {
                return 0;
            }
            return a.distance < b.distance ? -1 : 1;
        }

        /**
         * @description Method to check wheter store offers a given service
         * @param {String} serviceID store service
         * @returns {Boolean} true if store offers given service
         * @memberOf jwsdwStoreDetail.StoreDetailController
         */
        function _hasService(serviceID) {
            return vm.storeServices.some(function(service) {
                return service.id === serviceID;
            });
        }

        /**
         * @description Method to redirect to the service landing page
         * @param {String} servicePageUrl store service
         * @returns {void}
         * @memberOf jwsdwStoreDetail.StoreDetailController
         */
        function redirectToServicePage(servicePageUrl) {
            $window.location.href = servicePageUrl;
        }

        /**
         * @description Method to check if the browser supports HTML5 HistoryAPI.
         * @returns {Boolean} true if the browser supports the html 5 history API false otherwise
         * @memberOf jwsdwStoreDetail.StoreDetailController
         */
        function _browserSupportsHistoryAPI() {
            return $window.history && $window.history.pushState;
        }
    }
}(angular, app));
